export default "__VITE_ASSET__BBgfUURR__"